"use client";

import React from "react";
import { APIProvider } from "@vis.gl/react-google-maps";
import { getPublicEnv } from "../../runtime-utils/config/public-env";

export default function MapProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const apiKey = getPublicEnv("NEXT_PUBLIC_GOOGLE_MAPS_API_KEY");

  return <APIProvider apiKey={apiKey}>{children}</APIProvider>;
}
